import { useEffect } from 'react'
import { useWallet } from './use-wallet'
import { resolveWalletSync } from './wallet-signals'

/**
 * Компонент инициализации wallet connect
 * Монтируется в корне приложения для синхронизации состояния
 */
export const InitWallet = () => {
  const { isConnected } = useWallet()

  // Резолвим промис синхронизации после загрузки данных
  useEffect(() => {
    // Небольшая задержка чтобы дать время на загрузку данных с backend
    const timer = setTimeout(() => {
      resolveWalletSync()
    }, 100)

    return () => clearTimeout(timer)
  }, [isConnected])

  return null
}
